const img = '';

export default [
  {
    img: img,
    title: 'January 2022',
    description: `It all began when a mutual friend shared Alyssa’s contact with Reyner. To their surprise, Reyner had  been a junior classmate of Alyssa’s mother at STTRI. Little did they know, they attended the same Christmas service on campus five years earlier—two strangers, already stepping into each other’s story.`,
  },
  {
    img: img,
    title: 'March 2022',
    description: `From that first introduction, their conversations grew deeper, evolving from simple texts into hours of video calls. After two months of getting to know each other, they chose to begin their journey together in a committed relationship.`,
  },
  {
    img: img,
    title: 'August 2022',
    description: `Reyner began his Master’s program at Boston University, marking the start of their first chapter of long-distance relationship.`,
  },
  {
    img: img,
    title: 'August 2023',
    description: `Reyner and Alyssa got engaged! Surrounded by both families, they celebrated with a small,  kalungan ceremony, marking the formalization of their commitment. Soon after, Alyssa embarked on her Master’s program at the University of Glasgow, beginning their second season of long-distance.`,
  },
  {
    img: img,
    title: 'May 2024',
    description: `Reyner graduated with his M.T.S. degree from Boston, bringing them one step closer to their dreams.`,
  },
  {
    img: img,
    title: 'September 2024',
    description: `Alyssa received her M.Sc. in Glasgow, but as Reyner officially started his PhD program in Toronto, they knew one final stretch of long-distance was still ahead. Now, as they look forward to marriage, they can’t wait to finally close the distance—for good.`,
  },
];
